













import Vue, { PropType } from 'vue'
import { mapGetters } from 'vuex'
import mediaMixin from '../mixins/media-mixin'
import Person from '@/types/Person.interface'
import Media from '@/types/Media.interface'
import ScrollPosition from '@/types/components/ScrollPosition.interface'
import { MediaParams } from '@/types/PaginationParams.interface'
export default Vue.extend({
    mixins: [mediaMixin],
    props: {
        folder: {
            type: String,
            required: true
        },
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    data() {
        return {
            personMediaPlaceholder: {
                img: 'noDocuments',
                content: 'No Files to Display'
            }
        }
    },
    beforeDestroy() {
        //  When we leave, make sure we reset the media and params
        this.$store.commit('personSelectedMediaSet', [])
        //  Reset our pagination params
        this.$store.commit('personSelectedMediaPaginationReset')
    },
    async mounted() {
        //  Refresh the invoices list on load
        await this.$store.dispatch('personSelectedMediaPaginate', this.person.id)

        //  We are now mounted
        this.mounted = true
    },
    computed: {
        ...mapGetters({
            mediaParamsDefault: 'personSelectedMediaParamsDefault',
            lastPage: 'personSelectedMediaLastPage',
            paginating: 'personSelectedMediaPaginating',
            scrollPositionRight: 'scrollPositionRight'
        }),
        media(): Media[] {
            return this.$store.getters[this.path]
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        //  Our folder specified path
        path(): string {
            //  Get our proper cased folder name
            const folder = this.folder.toProperCase()

            //  Construct our full path
            return `personMedia${folder}`
        },
        personMediaParams: {
            get(): MediaParams {
                return this.$store.getters.personSelectedMediaParams
            },
            set(val: MediaParams): void {
                this.$store.commit('personSelectedMediaParamsSet', val)
            }
        }
    },

    methods: {
        //  Paginate the next page of the current filtered list
        paginateCurrentList(): void {
            //  Get current pagination params
            const params = this.personMediaParams

            //  Determine the next page
            const nextPage = params.page + 1

            //  Determine is the page exists, or we're already at the end of pagination
            const shouldPaginate = nextPage <= this.lastPage

            //  If we should NOT paginate, do nothing
            if (!shouldPaginate) return

            //  Else, update pagination params
            params.page = nextPage

            //  (our computed setter will apply this in the store)
            this.personMediaParams = params

            //  Paginate the next page
            this.$store.dispatch('personSelectedMediaPaginate', this.person.id)
        }
    },
    watch: {
        person(val: Person): void {
            if (val) {
                this.paginateCurrentList()
            }
        },
        scrollPositionRight(position: ScrollPosition): void {
            //  If we are NOT paginating AND scroll is at bottom, paginate next page
            if (!this.paginating && position.bottom) this.paginateCurrentList()
        }
    }
})
